// Lib
import { FC } from "react";
// Types
import { CheckboxProps as AntCheckboxProps } from "antd";
import { ControllerRenderProps } from "react-hook-form/dist/types/controller";
import { SvgIconConstituentValues } from "types/common";
// Components
import { Checkbox } from "components/Form";
// Styled
import { FlexContainer } from "styled/Box";

interface CheckboxWithTheIconProps extends AntCheckboxProps {
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  field: ControllerRenderProps<any, any>;
  label: string;
  Icon: FC<SvgIconConstituentValues>;
  disabled: boolean;
}

export const CheckboxWithTheIcon: FC<CheckboxWithTheIconProps> = ({
  label,
  Icon,
  field,
  disabled,
}) => {
  return (
    <FlexContainer $align="center" $justify="space-between">
      <FlexContainer $align="center">
        <Icon />
        <div style={{ marginLeft: 10 }}>{label}</div>
      </FlexContainer>
      <Checkbox
        {...field}
        checked={field.value}
        disabled={disabled}
        onChange={e => field.onChange(e.target.checked)}
      />
    </FlexContainer>
  );
};
